// extracted by mini-css-extract-plugin
module.exports = {"quizCard":"styles_quizCard__1dWg9"};